export default __webpack_public_path__ + "static/media/4.3e89bcd1.jpg";